import React from 'react';
import map from './map-forecast-slider.png';

export default [
  {
    // 1
    title: {
      text: "Manténgase informado",
      // style: { top: '21%', position: "absolute", left: '20%' },
      className: "caption lft slide_title_white slide_item_left"
    },
    description: [
      {
        text: <span>Centro Meterológico Provincial <br /><br />Santiago de Cuba</span>,
        // style: { width: "365px", position: "relative", top: '43%', left: '25%' },
        className: "caption lft slide_subtitle_white slide_item_left"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider1.jpg",
    backgroundColor: "linear-gradient(to right, rgb(33, 147, 176), rgb(109, 213, 237))",
    bgColor: true,
    images: [
      {
        src: "assets/frontend/onepage2/img/member/men2.png",
        style: { width: '28%', right: '19%', top: '31%', position: 'absolute' },
        className: "",
        id: "slide_img_logo"
      }
    ]
  },
  // 2
  {
    title: {
      text: "Pronóstico del Tiempo",
      // style: { top: '21%', position: "absolute", left: '20%' },
      className: "caption lft slide_title_white slide_item_left"
    },
    description: [
      {
        text: "Para nuestros Municipios",
        // style: { width: "365px", position: "relative", top: '43%', left: '25%' },
        className: "caption lft slide_subtitle_white slide_item_left"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider2.jpg",
    backgroundColor: "linear-gradient(to right, rgb(33, 147, 176), rgb(109, 213, 237))",
    image1: "assets/frontend/onepage2/img/widgets/map-screen.png",
    bgColor: true,
    images: [
      {
        src: map,
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: "",
        id: "slide_img_map"
      }
    ]
  },
  // 3
  {
    title: {
      text: "Alertas & Seguros",
      // style: { top: '10%', position: "absolute", left: '20%' },
      className: "caption lfl slide_title slide_item_left"
    },
    description: [
      {
        text: "Boletines, Reportes y Más",
        // style: { width: "275px", position: "relative", top: '17%', left: '20%' },
        className: "caption lfl slide_subtitle slide_item_left"
      },
      {
        text: "La información meteorológica a su disposición desde su puesto de trabajo",
        // style: { /* width: "350px", */ position: "relative", top: '18%', left: '20%' },
        className: "caption lfl slide_desc slide_item_left"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider2.jpg",
    bgColor: false,
    images: [
      {
        src: "assets/frontend/pages/img/revolutionslider/mac.png",
        style: { /* width: '50%',  */right: '10%', top: '27%', position: 'absolute' },
        className: "caption lfr slide_item_right",
        id: "slide_img_mac"
      },
      {
        src: "assets/frontend/pages/img/revolutionslider/ipad.png",
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: "caption lfr slide_item_right"
      },
      {
        src: "assets/frontend/pages/img/revolutionslider/iphone.png",
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: "caption lfr slide_item_right"
      },
      {
        src: "assets/frontend/pages/img/revolutionslider/macbook.png",
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: "caption lfr slide_item_right"
      }
    ],
    transition: {
      type: 'Slide',
      direction: 'left'
    }
  },
  // 4
  {
    title: {
      text: "Qué brindamos?",
      // style: { top: '10%', position: "absolute", left: '20%' },
      className: "caption lft slide_title"
    },
    description: [
      {
        text: "Servicios Científicos Técnicos",
        // style: { width: "320px", position: "relative", top: '17%', left: '20%' },
        className: "caption lft slide_subtitle"
      },
      {
        text: "Estaciones Automáticas en tiempo real",
        // style: { width: "405px", position: "relative", top: '18%', left: '20%' },
        className: "caption lft slide_subtitle"
      },
      {
        text: "Boletines Meteorológicos y Agrometeorológicos",
        // style: { width: "530px", position: "relative", top: '19%', left: '20%' },
        className: "caption lft slide_subtitle"
      },
      {
        text: "Alertas Informativas sobre el Pronóstico del Tiempo",
        // style: { width: "555px", position: "relative", top: '20%', left: '20%' },
        className: "caption lft slide_subtitle"
      },
      {
        text: "Sistema Provincial de Alerteas Hidrometerológicas",
        // style: { width: "540px", position: "relative", top: '21%', left: '20%' },
        className: "caption lft slide_subtitle"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider2.jpg",
    bgColor: false,
    images: [
      {
        src: "assets/frontend/pages/img/revolutionslider/servicios old.png",
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: "caption lft start",
        id: "slide_img_serv"
      }
    ]
  },
  // 5
  {
    title: {
      text: <h3 className="title-v2">Únete <br /></h3>,
      // style: { top: '40%', position: "absolute", left: '18%' },
      className: "caption lft tp-resizeme"
    },
    description: [
      {
        text: <p className="subtitle-v1">Colabora con el flujo de información del centro</p>,
        // style: { width: "100%", position: "absolute", top: '50%', left: '18%' },
        className: "caption lft tp-resizeme"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider2.jpg",
    bgColor: false,
    images: [
      {
        src: "assets/frontend/onepage2/img/widgets/device.png",
        style: { width: '35%', right: '13%', top: '55%', position: 'absolute' },
        className: "caption lfb tp-resizeme",
        id: "slide_img_device"
      }
    ]
  },
  // 6
  {
    title: {
      text: <h3>Esperamos su visita</h3>,
      // style: { top: '42%', position: "absolute", left: '31%' },
      className: "caption lft tp-resizeme slide-center-title"
    },
    description: [
      {
        text: <h3 className="red-title">Pensamos siempre en usted</h3>,
        // style: { width: "100%", position: "relative", top: '55%' },
        className: "caption lft tp-resizeme slide-center-subtitle"
      }
    ],
    backgroundImage: "assets/frontend/onepage2/img/bg/bg_slider3.jpg",
    bgColor: false,
    images: [
      {
        src: "",
        style: { width: '50%', right: '10%', top: '27%', position: 'absolute' },
        className: ""
      }
    ]
  }
];